import React from 'react';
import { AppleIcon, ArrowRightIcon } from 'lucide-react';
export function CTA() {
  return <section className="w-full bg-[#0A0A0F] py-24 lg:py-32" data-id="element-8">
      <div className="max-w-5xl mx-auto px-6" data-id="element-9">
        <div className="relative rounded-3xl overflow-hidden" data-id="element-10">
          <div className="absolute inset-0 bg-gradient-to-br from-[#3B9EFF] via-[#2B7ED9] to-[#1B5EA9]" data-id="element-11"></div>
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30" data-id="element-12"></div>

          <div className="relative px-8 py-16 lg:px-16 lg:py-20 text-center" data-id="element-13">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight tracking-tight" data-id="element-14">
              Ready to transform your art listings?
            </h2>

            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-15">
              Join thousands of artists creating stunning, unique mockups that
              sell.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-16">
              <a href="https://apps.apple.com/us/app/artreal-ai-art-mockup-studio/id6766778360" target="_blank" rel="noopener noreferrer" className="group px-8 py-4 bg-white hover:bg-gray-100 text-[#3B9EFF] font-bold rounded-xl transition-all duration-200 flex items-center gap-3 shadow-xl" data-id="element-17">
                <AppleIcon className="w-5 h-5" data-id="element-18" />
                Download Free on iOS
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-19" />
              </a>
            </div>

            <p className="text-white/70 text-sm mt-8" data-id="element-20">
              Free 7-day trial • No credit card required • Cancel anytime
            </p>
          </div>
        </div>
      </div>
    </section>;
}